import Api from "../apiService";

class TripCargosApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/cargos`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/cargos/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/cargos`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/cargos/${id}`,
      data,
      Api.authHeaders()
    );
  }

  delete(companyId, id) {
    return Api.deleteRequest(
      `companies/${companyId}/cargos/${id}`,
      {},
      Api.authHeaders()
    );
  }
}

export default new TripCargosApi();
